<template>
    <div>
        <buttonlist @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Airlift_No" label="空运申请单编号"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Airlift_Type" label="空运/高速"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" label="创建人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" label="创建时间"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_Person" label="修改人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_Time" label="修改时间"></el-table-column>
                    <el-table-column prop="Status" label="状态">
                        <template scope="scope">
                            {{expStatus(scope.row.status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="reason" label="原因"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_Name" label="项目名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_Code" label="项目代码"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Cus_Nmae" label="客户名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Cus_Code" label="客户代码"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Dest" label="目的地"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Truck_Tonnage" label="货车吨位"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Shipkg" label="海运公斤"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Normal_Cost" label="正常费用" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Airlift_Cost" label="空运/高速费用" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Diff_Cost" label="差价" align="right"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="display: flex;">
                    <el-button type="primary" size="mini" @click.native="setStatus(1)" :disabled="!btn.submit">提交</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(4)" :disabled="!btn.close">关闭</el-button>
                    <!--<el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :http-request="uploadFile"
                            :auto-upload="true"
                            :limit="1"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">回单上传
                        </el-button>
                    </el-upload>-->
                </div>
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">空运申请单编号</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Master.Airlift_No" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td style="width:60px">状态</td>
                            <td style="width:150px;">
                                <el-input :value="expStatus(dataDetail.Master.Status)" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td style="width:60px">运输方式</td>
                            <td style="width:150px;">
                                <el-select filterable v-model="dataDetail.Master.Airlift_Type" size="mini">
                                    <el-option v-for="item in airliftTypeArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code" style="width:100%"></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <!--<td>项目编号</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Item_Code" type="text" size="mini" v-if="dataDetail.Master.Status != 0" :disabled="true"></el-input>
                                <el-input
                                        v-model="dataDetail.Master.Item_Code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                        v-if="dataDetail.Master.Status == 0"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItemCode()"></i>
                                </el-input>
                            </td>
                            <td>项目名称</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Item_Name" type="text" size="mini" :disabled="true"></el-input>
                            </td>-->
                            <td>客户代码</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Cus_Num" type="textarea" size="mini"></el-input>
                                <!--<el-input v-model="dataDetail.Master.Cus_Code" type="text" size="mini" v-if="dataDetail.Master.Status != 0" :disabled="true"></el-input>
                                <el-input
                                        v-model="dataDetail.Master.Cus_Code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                        v-if="dataDetail.Master.Status == 0"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCusCode()"></i>
                                </el-input>-->
                            </td>
                            <td>目的地</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Dest" type="text" size="mini"></el-input>
                            </td>
                            <td>货车吨位</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Truck_Tonnage" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <!--<td>客户名称</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Cus_Nmae" type="text" size="mini" :disabled="true"></el-input>
                            </td>-->

                            <td>海运公斤</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Shipkg" type="text" size="mini"></el-input>
                            </td>
                            <td>原因</td>
                            <td>
                                <el-input v-model="dataDetail.Master.reason" type="text" size="mini"></el-input>
                            </td>
                            <td>创建人</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Create_Person" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>创建时间</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Create_Time" type="datetime" size="mini"
                                                style="width:100%" :disabled="true"></el-date-picker>
                            </td>
                            <td>修改人</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Modify_Person" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>修改时间</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Master.Modify_Time" type="datetime" size="mini"
                                                style="width:100%" :disabled="true"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>是否紧急状态</td>
                            <td>
                                <el-checkbox v-model="dataDetail.Master.Urgent_Flag" :true-label='1' :false-label='0'>
                                </el-checkbox>
                            </td>
                            <td>责任部门编号</td>
                            <td>
                                <!--<el-input v-model="dataDetail.Master.Duty_DeptNum" type="text" size="mini"></el-input>-->
                                <el-input v-model="dataDetail.Master.Duty_DeptNum" type="text" size="mini" v-if="dataDetail.Master.Status != 0" :disabled="true"></el-input>
                                <el-input
                                        v-model="dataDetail.Master.Duty_DeptNum"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                        v-if="dataDetail.Master.Status == 0"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectDutyDeptNum()"></i>
                                </el-input>
                            </td>
                            <td>责任部门名称</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Duty_Dept" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>备注</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Remark" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <el-divider content-position="left">物流专员</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>正常费用</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Normal_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>空运/高速费用</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Airlift_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>差价</td>
                            <td>
                                <el-input v-model="dataDetail.Master.Diff_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-table :data="dataDetail.DTAuditInfo" :height="tableHeight - 300" size="mini" border
                          style="width: 100%;" header-row-class-name="headerclass">
                    <!--<el-table-column show-overflow-tooltip prop="Sort" label="审核人顺序"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="Audit_Person" label="审核人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>
                    <el-table-column prop="Audit_Status" label="审核状态">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" label="审核日期"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" label="驳回意见"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,1)" type="text" size="small">审核</el-button>
                            <el-button style="padding:0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,2)" type="text" size="small">驳回</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="LogAirViewInfo" ref="ser" @getser="serclick"></serce>
        <el-dialog v-dialogDrag
                   title="请填写驳回原因"
                   :visible.sync="CloseDialogVisible"
                   width="30%"
        >
            <el-input
                    type="textarea"
                    :rows="5"
                    v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmAudit(selectrow,2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getItemCode" ref="itemcode"></selector>
        <selector :isVisible="false" :selectType="2" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSALCustomerDataList'" @callback="getCusCode" ref="cuscode"></selector>

        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetDeptDataList'" @callback="getDutyDeptNum" ref="dutydeptnum"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'logairlift',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                code: '',
                dataDetail: {
                    Master: {},
                    DTAuditInfo: []
                },
                airliftTypeArray: [
                    {
                        Code: '空运',
                        Name: '空运'
                    },
                    {
                        Code: '高速',
                        Name: '高速'
                    },
                ],
                CloseDialogVisible: false,
                selectrow: {},
                resontxt: '',
                uploadurl: '',
                fileList: [],
                file: null,
                btn: {
                  submit: false,
                  close: false,
                },
                oldrow: '',
                currentAuditId: 0
            };
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('logairlift', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.getView();
            that.confirmAdd();
        },
        methods: {
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.submit = false
                that.btn.close = true
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Airlift_No)){
                    if(that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 3){
                        that.btn.submit = true
                    }
                } else {
                    that.btn.submit = false
                    that.btn.close = false
                }
                that.currentAuditId = 0
                if(that.dataDetail.DTAuditInfo.length > 0) {
                    let arr = that.dataDetail.DTAuditInfo.filter(row => row.Audit_Status == 0 || row.Audit_Status == 2)
                    let compare = function (obj1, obj2) {
                        let val1 = obj1.Sort;
                        let val2 = obj2.Sort;
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    let sortArr = arr.sort(compare);
                    if(sortArr.length > 0){
                        that.currentAuditId = sortArr[0].Exclusively_ID
                    }
                }
            },
            tableRowClassName({row, rowIndex}) {
                if (row.Urgent_Flag == true) {
                    return 'red';
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'LogAirViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/LogAirlift/GetLogAirliftView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.oldrow = row
                            that.addoredit = 2;
                            that.code = row.Exclusively_ID
                            that.getDetail(that.code);
                        })
                        .catch(() => {
                            that.$refs.singleTable.setCurrentRow(that.oldrow);
                        });
                } else {
                    that.oldrow = row
                    that.addoredit = 2;
                    that.code = row.Exclusively_ID
                    that.getDetail(that.code);
                }
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                let parm = {
                    Code: code
                };
                that.$http.urlpost('/LogAirlift/LogAirliftInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.confirmAdd()
                        });
                } else {
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = (
                    new Date().getFullYear() +
                    '-' +
                    (new Date().getMonth() + 1) +
                    '-' +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    ':' +
                    new Date().getMinutes() +
                    ':' +
                    new Date().getSeconds()
                ).toString();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Master: {
                        Exclusively_ID: 0,
                        Relation_IID: 0,
                        Airlift_No: '',
                        Airlift_Type: '空运',
                        Create_Person: '',
                        Create_Time: '',
                        Modify_Person: '',
                        Modify_Time: '',
                        Status: 0,
                        Remark: '',
                        reason: '',
                        Item_Name: '',
                        Item_Code: '',
                        Cus_Nmae: '',
                        Cus_Code: '',
                        Dest: '',
                        Truck_Tonnage: '',
                        Shipkg: '',
                        Normal_Cost: 0,
                        Airlift_Cost: 0,
                        Diff_Cost: 0,
                        IsEdit: 1,
                        Audit_Person: '',
                        Urgent_Flag: true,
                        Duty_Dept: '',
                        Duty_DeptNum: '',
                        Cus_Num: ''
                    },
                    DTAuditInfo: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.isEdit){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.isEdit){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/LogAirlift/GetLogAirliftViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail.Master;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogAirlift/SaveLogAirlift', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getView()
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });

            },
            expStatus(val){
                if(val == 0){
                    return '生成'
                } else if(val == 1){
                    return '审核'
                } else if(val == 2){
                    return '批准'
                } else if(val == 3){
                    return '驳回'
                } else if(val == 4){
                    return '关闭'
                } else {
                    return ''
                }
            },
            expAuditStatus(val){
                if(val == 0){
                    return '待审'
                } else if(val == 1){
                    return '审核'
                } else if(val == 2){
                    return '驳回'
                } else {
                    return ''
                }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: that.dataDetail.Master.Exclusively_ID
                        }
                        that.$http.urlpost('/LogAirlift/DelLogAirliftByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 1提交4关闭
            setStatus(val){
                let that = this;
                that.dataDetail.Master.Status = val
                let parm = that.dataDetail.Master;
                parm.LangType=that.$processdata.getLang()
                that.$http.urlpost('/LogAirlift/LogAirliftSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.getDetail(that.code)
                });
            },
            // 审核 驳回
            Audit(scope,flag){
                let that =this;
                if(flag == 1){
                    this.$confirm(that.$t('getapi[8606]'), that.$t('getapi[194]'), {//'确认审核通过吗'
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.confirmAudit(scope.row,1)
                        })
                        .catch(() => {
                        });
                } else if(flag==2){
                    that.CloseDialogVisible = true;
                    that.selectrow = scope.row;
                    that.resontxt = '';
                }
            },
            confirmAudit(row,type){
                let that = this
                row.Audit_Date = that.$limits.getDateTime()
                if(type == 1){
                    row.Audit_Msg = ''
                } else {
                    row.Audit_Msg = that.resontxt
                }
                row.Audit_Status = type
                let parm = row
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogAirlift/LogAirliftInfoSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView();
                        that.getDetail(that.code);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                    }
                });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Exclusively_ID', that.dataDetail.Master.Exclusively_ID)
                formData.append('Actual_Cost', that.dataDetail.Master.Actual_Cost)
                that.$http.urlpost('/LogCar/UploadFilesResult', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dataSet = res.DataContent
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 查看文件
            open(url){
                let that = this
                let hrefurl = Common.Url + url;
                window.open(hrefurl);
            },
            selectItemCode() {
                let that = this;
                that.$refs.itemcode.clearInput(true);
            },
            getItemCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Item_Code = val.item_code;
                that.dataDetail.Master.Item_Name = val.item_name;
            },
            selectCusCode() {
                let that = this;
                that.$refs.cuscode.clearInput(true);
            },
            getCusCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Cus_Code = val.customer_id;
                that.dataDetail.Master.Cus_Nmae = val.customer_name;
            },
            checkDataChange(){
                let that = this
                //能打开此页面即拥有保存权限
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
            selectDutyDeptNum(){
                let that = this;
                that.$refs.dutydeptnum.clearInput(true);
            },
            getDutyDeptNum(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Duty_DeptNum = val.num;
                that.dataDetail.Master.Duty_Dept = val.name;
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
